import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { Space, Typography, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

import moment from 'moment';

import Container, { Description, GridColumsContainer } from './container';

import { redirectToDistribution } from 'actions/distribution';
import { useUserMe } from 'apiTyped/hooks/users.query';

const { Text } = Typography;
const isMobile = window.innerWidth <= 845;

const ShowButton = styled(Button).attrs(() => ({
  type: 'primary',
  shape: 'circle',
  icon: <EyeOutlined />
}))`
  background-color: ${(props) => props.theme.colors['terra-cotta']};
  color: ${(props) => props.theme.colors['white']};

  &.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: ${(props) => props.theme.colors['white']};
  }
`;

const getTypeColor = (type) => {
  switch (type) {
    case 'distribution':
      return '#f06543';
    case 'press':
      return '#bcb9a0';
    case 'notation':
      return '#323739';
    default:
      return '#d55d3f';
  }
};

const renderItemDescription = (item, index) => {
  if (typeof item !== 'object' || !item.subList) {
    return item;
  }

  return (
    <div>
      {item.header && (
        <p key={[index, 'header'].join('_')} style={{ fontWeight: 'bold' }}>
          {item.header}
        </p>
      )}
      <ul key={[index, 'list'].join('_')} style={{ marginBottom: 10 }}>
        {item.subList.slice(0, 3).map((elem, list_index) => (
          <li key={[index, 'list', list_index].join('_')}>{elem}</li>
        ))}
      </ul>
    </div>
  );
};

const renderDescription = (type, description, descriptionList) => {
  let descList = [];

  if (descriptionList) {
    descList = descriptionList.map((item, index) =>
      renderItemDescription(item, index)
    );
    if (descList.length > 4) {
      descList = descList.slice(0, 4);
      descList.push('...');
    }
  }

  return isEmpty(descriptionList) && isEmpty(descList) ? (
    <Description key={type}>{description}</Description>
  ) : isMobile ? (
    <Description key={0} className="description-mobile">
      {descList.slice(0, 1)}
      {descList.length > 1 ? '...' : ''}
    </Description>
  ) : (
    map(descList, (item, index) => (
      <Description key={index}>{item}</Description>
    ))
  );
};

const FeedItem = ({
  type,
  title,
  origin, // HERE prettier warning
  date,
  description,
  link,
  descriptionList,
  toRedirectDistribution,
  redirectToDistribution
}) => {
  const { user } = useUserMe();
  const onClick = toRedirectDistribution
    ? () => {
        redirectToDistribution({
          ...toRedirectDistribution,
          isBranded: user.isBranded
        });
      }
    : undefined;

  // Caves restos supp 'nouveau relevé'
  // dans ventes en ligens ajout des prix basse > -5%
  return (
    <Container>
      <div
        style={{
          backgroundColor: getTypeColor(type),
          borderRadius: '5px 0 0 5px'
        }}
      />
      <GridColumsContainer>
        <Space direction="vertical" className="spaceContent">
          <p className="information-type">{title.toUpperCase()}</p>
          <p className="information-origin">{origin?.toUpperCase()}</p>
          <div className="colContainer">
            {renderDescription(type, description, descriptionList)}
          </div>
          <Text type="secondary">
            {moment(date, 'DD/MM/YYYY').format('ll')}
          </Text>
        </Space>
        {link && !isMobile && (
          <div className="buttonShow">
            <Link to={link}>
              <ShowButton onClick={onClick} />
            </Link>
          </div>
        )}
      </GridColumsContainer>
    </Container>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  redirectToDistribution: (value) => dispatch(redirectToDistribution(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedItem);
